import { isEdge } from "./api/backend"
export default function EdgeWarning(props: { children: React.ReactNode }) {
    
    return isEdge() ? <div style={{ backgroundColor: "pink" }}>
        {props.children}
    </div> : <>{props.children}</>

}